/**
 * To protected pages
 */

import React, { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isAuthorized } from './Authentication';
import { connectString } from './Utils';
import AppContext from 'context/Context';

const ProtectedElement = () => {
  const {
    config: { corp }
  } = useContext(AppContext);

  const isHome = pa => {
    if (!pa) return true;
    if (pa == '/') return true;
    if (pa == '/s') return false;
    const reg = new RegExp('^/(\\w+)/?$');
    const reg_result = reg.exec(window.location.pathname);
    return !!reg_result;
  };

  const is_auth = isAuthorized(corp);
  const from = useLocation().pathname;
  const to = isHome(from)
    ? process.env.REACT_APP_LOGIN_PATH
    : process.env.REACT_APP_LOGIN_PATH + '?form=' + from;

  return is_auth ? <Outlet /> : <Navigate to={connectString(corp, to, '/')} />;
};

export default ProtectedElement;
